/**
 * @generated SignedSource<<f79768abbb0a5e76bcef3417769e4caa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditMainPayments_order$data = {
  readonly paymentTypeText: string | null;
  readonly priceAdvancePayment: number | null;
  readonly priceTotal: number;
  readonly remainingPayment: number;
  readonly remainingPaymentDeadline: string | null;
  readonly totalPaid: number;
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditInvoice_order" | "OrderEditMainPaymentsTable_order">;
  readonly " $fragmentType": "OrderEditMainPayments_order";
};
export type OrderEditMainPayments_order$key = {
  readonly " $data"?: OrderEditMainPayments_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditMainPayments_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderEditMainPayments_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceTotal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceAdvancePayment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalPaid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingPayment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingPaymentDeadline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentTypeText",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrderEditMainPaymentsTable_order"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrderEditInvoice_order"
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "efaa71436084969b6450644a21b0d559";

export default node;
